import { render, staticRenderFns } from "./ClientAddressForm.vue?vue&type=template&id=15507588&scoped=true"
import script from "./ClientAddressForm.vue?vue&type=script&lang=ts"
export * from "./ClientAddressForm.vue?vue&type=script&lang=ts"
import style0 from "./ClientAddressForm.vue?vue&type=style&index=0&id=15507588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15507588",
  null
  
)

export default component.exports